import React, {useCallback, useState} from 'react';

import {useStore} from 'effector-react';

import {useTranslation} from 'react-i18next';

import {I18N_NS} from '../../../../../core/constants/names';
import {
    $invoiceLineChargeData,
    $invoiceLinesHolder,
    setInvoiceLinesHolder,
} from '../../../../../models/create';
import {
    $modalDuplicateLinesModal,
    setModalDuplicateLinesModal,
} from '../../../../../models/details';
import {InvocieLineHolder, InvoiceLine} from '../../../../../types/invoices';

import {Button, ButtonVariant} from '../../../../ui-kit/Button';
import {Input} from '../../../../ui-kit/Input';
import {Modal} from '../../../../ui-kit/Modal';

import {ButtonWrapper} from './styled';

export const ModalDuplicateLines = () => {
    const modalDuplicateLinesModal = useStore($modalDuplicateLinesModal);
    const invoiceLinesHolder = useStore($invoiceLinesHolder);
    const invoiceLineChargeData = useStore($invoiceLineChargeData);
    const {index: lineId = -1, show: isShow, initialLineData} = modalDuplicateLinesModal;
    const {t: translation} = useTranslation(I18N_NS);
    const GEN_INFO = 'pages.documents.invoices.modalDuplicateLines';
    const t = (key: string, vars?: Record<string, any>) =>
        translation(`${GEN_INFO}.${key}`, vars ?? {});
    const [value, setValue] = useState<number | undefined>(undefined);

    const handleCloseCallback = useCallback(() => {
        setModalDuplicateLinesModal({index: -1, show: false});
        setValue(undefined);
    }, [setModalDuplicateLinesModal]);

    const createDuplicateLine = useCallback(
        (sourceLine: InvoiceLine): InvoiceLine => ({
            itemCode: sourceLine.itemCode,
            description: sourceLine.description,
            isHsn: sourceLine.isHsn,
            serviceCategory: sourceLine.serviceCategory,
            qty: sourceLine.qty,
            price: sourceLine.price,
            lines: sourceLine.lines,
            vatCategory: sourceLine.vatCategory,
            vat: sourceLine.vat,
            lineAmountWVat: sourceLine.lineAmountWVat,
            charges: sourceLine.charges,
            isMarkedItem: sourceLine.isMarkedItem,
            copyActions: sourceLine.copyActions,
        }),
        [],
    );

    function appendItems() {
        if (!value || value <= 0 || !Number.isInteger(value)) {
            return;
        }

        if (lineId >= invoiceLinesHolder.length) {
            handleCloseCallback();
            return;
        }

        const sourceLine =
            lineId === -1 && initialLineData
                ? (initialLineData as InvoiceLine)
                : invoiceLinesHolder[lineId];

        if (lineId === -1 && invoiceLineChargeData) {
            sourceLine.charges = invoiceLineChargeData;
        }

        if (!sourceLine) {
            handleCloseCallback();
            return;
        }

        const newLines: InvoiceLine[] = Array.from({length: value}, () =>
            createDuplicateLine(sourceLine as InvoiceLine),
        );

        setInvoiceLinesHolder(newLines as InvocieLineHolder[]);

        handleCloseCallback();
    }

    return (
        <Modal title={t('title')} show={isShow} modalWidth={0} onClose={handleCloseCallback}>
            <Input
                type="number"
                label={t('inputLabel')}
                disabled={false}
                placeholder={t('inputPlaceholder')}
                value={value}
                onChange={(e) => setValue(Number(e.target.value))}
            />
            <ButtonWrapper>
                <Button type="button" onClick={handleCloseCallback} variant={ButtonVariant.Outline}>
                    {t('cancel')}
                </Button>
                <Button type="button" variant={ButtonVariant.Normal} onClick={appendItems}>
                    {t('save')}
                </Button>
            </ButtonWrapper>
        </Modal>
    );
};
